import { useAppData } from "./App.tsx";
import { useSignal } from "@preact/signals";

export function WelcomeForm() {
  const appData = useAppData();
  const error = useSignal('');
  const loading = useSignal(false);
  const role = useSignal('');

  async function onSubmit(e: SubmitEvent) {
    e.preventDefault();

    const form = e.currentTarget as HTMLFormElement;
    const formData = new FormData(form);
    const data = Object.fromEntries(formData.entries());

    try {
      error.value = '';
      loading.value = true;

      console.log("Form data submitted:", data);

      const res = await fetch('/api/user-info', { body: formData, method: "POST" });

      if (!res.ok) throw new Error(await res.text());

      location.href = appData.siteURL;
    } catch (e) {
      console.error(e);
      error.value = e.message;
    }
    finally {
      loading.value = false;
    }
  }

  // Basic styles for labels to improve readability
  const labelStyle = { display: 'block', marginTop: '1rem', marginBottom: '0.25rem', fontWeight: 'bold' };

  return <div class="welcome-form">
    <form onSubmit={onSubmit}>
      <div class="dropdowns">
        <div>
          <label style={labelStyle} for="role">Your Role</label>
          <select name="role" id="role" required onChange={e => role.value = e.currentTarget.value}>
            <option value="" disabled selected>Select your role...</option>
            <option value="sales">Sales</option>
            <option value="operation">Operation</option>
            <option value="executive">Executive</option>
            <option value="marketing">Marketing</option>
            <option value="other">Other</option>
          </select>
        </div>
        <div>
          <label style={labelStyle} for="aiProficiency">AI Proficiency</label>
          <select name="aiProficiency" id="aiProficiency" required>
            <option value="" disabled selected>Select proficiency level...</option>
            <option value="low">Low</option>
            <option value="medium">Medium</option>
            <option value="high">High</option>
          </select>
        </div>
        <div>
          <label style={labelStyle} for="communicationPreference">Conversation Style</label>
          <select name="communicationPreference" id="communicationPreference" required>
            <option value="balanced">Balanced</option>
            <option value="conversational">Conversational</option>
            <option value="concise">Concise</option>
          </select>
        </div>
      </div>

      <label style={labelStyle} for="challenges">What are your biggest challenges or friction points right now? (optional)</label>
      <textarea
        id="challenges"
        name="challenges"
        rows={4}
        placeholder="Share anything that you want me to keep in mind and look for opportunities to help."
      />

      <label style={labelStyle} for="tools">What tools and systems do you use most in your workflow? (optional)</label>
      <textarea
        id="tools"
        name="tools"
        rows={4}
        placeholder="List anything that you think will help me align my interactions with your workflow."
      />

      <label style={labelStyle} for="selfImprovements">What are 1-3 things you wish you could do better or faster in your role? (optional)</label>
      <textarea
        id="selfImprovements"
        name="selfImprovements"
        rows={4}
        placeholder="These are areas I can focus on as we develop conversations."
      />

      {role.value == "sales" && <>
        <label style={labelStyle} for="salesStage">If you're in sales, what stage of the sales process do you spend most of your time in? (optional)</label>
        <textarea
          id="salesStage"
          name="salesStage"
          rows={2}
          placeholder="e.g., Prospecting, discovery, demo/presentation, negotiation, closing, post-sale/expansion"
        />

        <label style={labelStyle} for="salesBuyerLevel">If you're in sales, what level of buyer do you most often engage with? (optional)</label>
        <textarea
          id="salesBuyerLevel"
          name="salesBuyerLevel"
          rows={2}
          placeholder="e.g., Managers, directors, VPs, C-suite, multiple levels"
        />
      </>}

      <button disabled={loading.value} type="submit" style={{ marginTop: '1.5rem' }}>
        Begin your Ignite journey
      </button>
      {error.value && <div class="error">{error.value}</div>}
    </form>
  </div>
}